// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API (params in:body)
 * Ads API allows you to interact directly with the Instacart Ads platform, programmatically managing accounts and advertising campaigns. The API accepts form-encoded requests and returns JSON-encoded response.  We provide OAuth2 for authentication. API requests must supply an Authorization header with a token header as follows: \"Authorization\": \"Bearer <access_token>\".  Using *X-Api-Key* and *X-Secret-Key* request headers for authentication to be deprecated.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import type { ApiDisplayAdGroupsControllerAppealInput } from '../models/ApiDisplayAdGroupsControllerAppealInput'
import {
  ApiDisplayAdGroupsControllerAppealInputFromJSON,
  ApiDisplayAdGroupsControllerAppealInputToJSON,
} from '../models/ApiDisplayAdGroupsControllerAppealInput'
import type { ApiDisplayAdGroupsControllerCreateInput } from '../models/ApiDisplayAdGroupsControllerCreateInput'
import {
  ApiDisplayAdGroupsControllerCreateInputFromJSON,
  ApiDisplayAdGroupsControllerCreateInputToJSON,
} from '../models/ApiDisplayAdGroupsControllerCreateInput'
import type { ApiDisplayAdGroupsControllerDuplicateAsyncInput } from '../models/ApiDisplayAdGroupsControllerDuplicateAsyncInput'
import {
  ApiDisplayAdGroupsControllerDuplicateAsyncInputFromJSON,
  ApiDisplayAdGroupsControllerDuplicateAsyncInputToJSON,
} from '../models/ApiDisplayAdGroupsControllerDuplicateAsyncInput'
import type { ApiDisplayAdGroupsControllerEnableInput } from '../models/ApiDisplayAdGroupsControllerEnableInput'
import {
  ApiDisplayAdGroupsControllerEnableInputFromJSON,
  ApiDisplayAdGroupsControllerEnableInputToJSON,
} from '../models/ApiDisplayAdGroupsControllerEnableInput'
import type { ApiDisplayAdGroupsControllerSubmitInput } from '../models/ApiDisplayAdGroupsControllerSubmitInput'
import {
  ApiDisplayAdGroupsControllerSubmitInputFromJSON,
  ApiDisplayAdGroupsControllerSubmitInputToJSON,
} from '../models/ApiDisplayAdGroupsControllerSubmitInput'
import type { ApiDisplayAdGroupsControllerUpdateInput } from '../models/ApiDisplayAdGroupsControllerUpdateInput'
import {
  ApiDisplayAdGroupsControllerUpdateInputFromJSON,
  ApiDisplayAdGroupsControllerUpdateInputToJSON,
} from '../models/ApiDisplayAdGroupsControllerUpdateInput'
import type { AppealDisplayAdGroupsResponse } from '../models/AppealDisplayAdGroupsResponse'
import {
  AppealDisplayAdGroupsResponseFromJSON,
  AppealDisplayAdGroupsResponseToJSON,
} from '../models/AppealDisplayAdGroupsResponse'
import type { AsyncTaskResponse } from '../models/AsyncTaskResponse'
import { AsyncTaskResponseFromJSON, AsyncTaskResponseToJSON } from '../models/AsyncTaskResponse'
import type { DisplayAdGroupResponse } from '../models/DisplayAdGroupResponse'
import {
  DisplayAdGroupResponseFromJSON,
  DisplayAdGroupResponseToJSON,
} from '../models/DisplayAdGroupResponse'
import type { DisplayAdGroupsResponse } from '../models/DisplayAdGroupsResponse'
import {
  DisplayAdGroupsResponseFromJSON,
  DisplayAdGroupsResponseToJSON,
} from '../models/DisplayAdGroupsResponse'
import type { EnableDisplayAdGroupResponse } from '../models/EnableDisplayAdGroupResponse'
import {
  EnableDisplayAdGroupResponseFromJSON,
  EnableDisplayAdGroupResponseToJSON,
} from '../models/EnableDisplayAdGroupResponse'
import type { ErrorResponseGroup } from '../models/ErrorResponseGroup'
import { ErrorResponseGroupFromJSON, ErrorResponseGroupToJSON } from '../models/ErrorResponseGroup'
import type { GetDisplayAdGroupAnalyticsResponse } from '../models/GetDisplayAdGroupAnalyticsResponse'
import {
  GetDisplayAdGroupAnalyticsResponseFromJSON,
  GetDisplayAdGroupAnalyticsResponseToJSON,
} from '../models/GetDisplayAdGroupAnalyticsResponse'

export interface GetDisplayAdGroupsRequest {
  campaignId: string
  searchCriteriaDateRangeStartDate?: string
  searchCriteriaDateRangeEndDate?: string
  searchCriteriaStatus?: Array<GetDisplayAdGroupsSearchCriteriaStatusEnum>
  searchCriteriaQuery?: string
  sortCriteriaField?: GetDisplayAdGroupsSortCriteriaFieldEnum
  sortCriteriaDirection?: GetDisplayAdGroupsSortCriteriaDirectionEnum
  pageCriteriaPage?: number
  pageCriteriaItemsPerPage?: number
  includeAnalytics?: boolean
  attributionModels?: Array<string>
  xApiKey?: string
  xSecretKey?: string
}

export interface GetDisplayAdGroupsIdRequest {
  id: string
  analyticsType?: GetDisplayAdGroupsIdAnalyticsTypeEnum
  dateRangeStartDate?: string
  dateRangeEndDate?: string
  includeAnalytics?: boolean
  attributionModels?: Array<string>
  xApiKey?: string
  xSecretKey?: string
}

export interface GetDisplayAdGroupsIdAnalyticsRequest {
  metric: GetDisplayAdGroupsIdAnalyticsMetricEnum
  id: string
  analyticsType?: GetDisplayAdGroupsIdAnalyticsAnalyticsTypeEnum
  dateRangeStartDate?: string
  dateRangeEndDate?: string
  xApiKey?: string
  xSecretKey?: string
}

export interface PostDisplayAdGroupsRequest {
  xApiKey?: string
  xSecretKey?: string
  body?: ApiDisplayAdGroupsControllerCreateInput
}

export interface PostDisplayAdGroupsIdDuplicateAsyncRequest {
  id: string
  xApiKey?: string
  xSecretKey?: string
  body?: ApiDisplayAdGroupsControllerDuplicateAsyncInput
}

export interface PostDisplayAdGroupsSubmitRequest {
  xApiKey?: string
  xSecretKey?: string
  body?: ApiDisplayAdGroupsControllerSubmitInput
}

export interface PutDisplayAdGroupsIdRequest {
  id: string
  xApiKey?: string
  xSecretKey?: string
  body?: ApiDisplayAdGroupsControllerUpdateInput
}

export interface PutDisplayAdGroupsIdAppealRequest {
  id: string
  xApiKey?: string
  xSecretKey?: string
  body?: ApiDisplayAdGroupsControllerAppealInput
}

export interface PutDisplayAdGroupsIdEnableRequest {
  id: string
  xApiKey?: string
  xSecretKey?: string
  body?: ApiDisplayAdGroupsControllerEnableInput
}

/**
 *
 */
export class DisplayAdGroupsApi extends runtime.BaseAPI {
  /**
   * This method returns a list of all display ad groups under a specific display campaign. You can optionally search for a specific display ad group name and this method returns only the corresponding display ad groups. You can also send filter criteria as parameters and this method will only return the corresponding display ad groups.    This method returns details for each display ad group, including its attributes and optional performance analytics.
   * Retrieve all display ad groups
   */
  async getDisplayAdGroupsRaw(
    requestParameters: GetDisplayAdGroupsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<DisplayAdGroupsResponse>> {
    if (requestParameters.campaignId === null || requestParameters.campaignId === undefined) {
      throw new runtime.RequiredError(
        'campaignId',
        'Required parameter requestParameters.campaignId was null or undefined when calling getDisplayAdGroups.'
      )
    }

    const queryParameters: any = {}

    if (requestParameters.campaignId !== undefined) {
      queryParameters['campaign_id'] = requestParameters.campaignId
    }

    if (requestParameters.searchCriteriaDateRangeStartDate !== undefined) {
      queryParameters['search_criteria[date_range][start_date]'] =
        requestParameters.searchCriteriaDateRangeStartDate
    }

    if (requestParameters.searchCriteriaDateRangeEndDate !== undefined) {
      queryParameters['search_criteria[date_range][end_date]'] =
        requestParameters.searchCriteriaDateRangeEndDate
    }

    if (requestParameters.searchCriteriaStatus) {
      queryParameters['search_criteria[status]'] = requestParameters.searchCriteriaStatus.join(
        runtime.COLLECTION_FORMATS['csv']
      )
    }

    if (requestParameters.searchCriteriaQuery !== undefined) {
      queryParameters['search_criteria[query]'] = requestParameters.searchCriteriaQuery
    }

    if (requestParameters.sortCriteriaField !== undefined) {
      queryParameters['sort_criteria[field]'] = requestParameters.sortCriteriaField
    }

    if (requestParameters.sortCriteriaDirection !== undefined) {
      queryParameters['sort_criteria[direction]'] = requestParameters.sortCriteriaDirection
    }

    if (requestParameters.pageCriteriaPage !== undefined) {
      queryParameters['page_criteria[page]'] = requestParameters.pageCriteriaPage
    }

    if (requestParameters.pageCriteriaItemsPerPage !== undefined) {
      queryParameters['page_criteria[items_per_page]'] = requestParameters.pageCriteriaItemsPerPage
    }

    if (requestParameters.includeAnalytics !== undefined) {
      queryParameters['include_analytics'] = requestParameters.includeAnalytics
    }

    if (requestParameters.attributionModels) {
      queryParameters['attribution_models'] = requestParameters.attributionModels.join(
        runtime.COLLECTION_FORMATS['csv']
      )
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (requestParameters.xApiKey !== undefined && requestParameters.xApiKey !== null) {
      headerParameters['X-Api-Key'] = String(requestParameters.xApiKey)
    }

    if (requestParameters.xSecretKey !== undefined && requestParameters.xSecretKey !== null) {
      headerParameters['X-Secret-Key'] = String(requestParameters.xSecretKey)
    }

    const response = await this.request(
      {
        path: `/display/ad_groups`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      DisplayAdGroupsResponseFromJSON(jsonValue)
    )
  }

  /**
   * This method returns a list of all display ad groups under a specific display campaign. You can optionally search for a specific display ad group name and this method returns only the corresponding display ad groups. You can also send filter criteria as parameters and this method will only return the corresponding display ad groups.    This method returns details for each display ad group, including its attributes and optional performance analytics.
   * Retrieve all display ad groups
   */
  async getDisplayAdGroups(
    requestParameters: GetDisplayAdGroupsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<DisplayAdGroupsResponse> {
    const response = await this.getDisplayAdGroupsRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   * This method returns details about a specific display ad group, and optionally includes performance analytics. You must specify the display ad group ID and optional search criteria to limit the data returned in the analytics.      <h3>Targeting shortcuts</h3>     <table>      <tr>         <th>Name</th>         <th>Description</th>         <th>Sample user_targeting</th>      </tr>      <tr>         <td>NEW_TO_INSTACART</td>         <td>Target any customer adding to their first few carts.</td>         <td>            { \'new_to_instacart\': true }         </td>      </tr>      <tr>         <td>NEW_TO_CATEGORY_OR_BRAND</td>         <td>Reach customers who have never purchased from your brand or chosen categories.</td>         <td>            {            \'purchase\': [            {            \'categories\': [            \'DAIRY\'            ],            \'lookback_window\': \'30d\',            \'clause\': \'exclude\'            }            ]            }         </td>      </tr>      <tr>         <td>BUY_MY_CATEGORY_NOT_MY_BRAND</td>         <td>Get your brand in front of customers buying similar items from competitors.</td>         <td>            {            \'purchase\': [            {            \'categories\': [            \'DAIRY\'            ],            \'lookback_window\': \'30d\',            \'clause\': \'include\'            },            {            \'brand_ids\': [            \'912639\'            ],            \'lookback_window\': \'30d\',            \'clause\': \'exclude\'            }            ]            }         </td>      </tr>      <tr>         <td>BUY_MY_BRAND_NOT_MY_PRODUCT</td>         <td>Introduce a new product or upsell other items an existing customer might like.</td>         <td>            {            \'purchase\': [            {            \'brand_ids\': [            \'912639\'            ],            \'lookback_window\': \'30d\',            \'clause\': \'include\'            },            {            \'upcs\': [            \'00070153201005\'            ],            \'lookback_window\': \'30d\',            \'clause\': \'exclude\'            }            ]            }         </td>      </tr>      <tr>         <td>INTERACT_WITH_X_NOT_BUY_BRAND</td>         <td>Target customers who interact via search, clicking an item details page, or adding to cart.</td>         <td>            {            \'purchase\': [            {            \'brand_ids\': [            \'912639\'            ],            \'lookback_window\': \'30d\',            \'clause\': \'exclude\'            }            ],            \'interest\': [            {            \'categories\': [            \'DAIRY\'            ],            \'lookback_window\': \'30d\',            \'clause\': \'include\'            }            ]            }         </td>      </tr>      <tr>         <td>LAPSED_BUYER</td>         <td>Re-engage customers who haven\'t purchased your brand or category in X days.</td>         <td>            {            \'purchase\': [            {            \'brand_ids\': [            \'912639\'            ],            \'lookback_window\': \'30d\',            \'clause\': \'include\'            },            {            \'brand_ids\': [            \'912639\'            ],            \'lookback_window\': \'60d\',            \'clause\': \'exclude\'            }            ]            }         </td>      </tr>      <tr>         <td>LOYAL_BUYER</td>         <td>Deepen brand loyalty by encouraging repeat purchases from recent customers.</td>         <td>            {            \'purchase\': [            {            \'brand_ids\': [            \'912639\'            ],            \'lookback_window\': \'30d\',            \'clause\': \'include\'            }            ]            }         </td>      </tr>   </table>
   * Retrieve a display ad group
   */
  async getDisplayAdGroupsIdRaw(
    requestParameters: GetDisplayAdGroupsIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<DisplayAdGroupResponse>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter requestParameters.id was null or undefined when calling getDisplayAdGroupsId.'
      )
    }

    const queryParameters: any = {}

    if (requestParameters.analyticsType !== undefined) {
      queryParameters['analytics_type'] = requestParameters.analyticsType
    }

    if (requestParameters.dateRangeStartDate !== undefined) {
      queryParameters['date_range[start_date]'] = requestParameters.dateRangeStartDate
    }

    if (requestParameters.dateRangeEndDate !== undefined) {
      queryParameters['date_range[end_date]'] = requestParameters.dateRangeEndDate
    }

    if (requestParameters.includeAnalytics !== undefined) {
      queryParameters['include_analytics'] = requestParameters.includeAnalytics
    }

    if (requestParameters.attributionModels) {
      queryParameters['attribution_models'] = requestParameters.attributionModels.join(
        runtime.COLLECTION_FORMATS['csv']
      )
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (requestParameters.xApiKey !== undefined && requestParameters.xApiKey !== null) {
      headerParameters['X-Api-Key'] = String(requestParameters.xApiKey)
    }

    if (requestParameters.xSecretKey !== undefined && requestParameters.xSecretKey !== null) {
      headerParameters['X-Secret-Key'] = String(requestParameters.xSecretKey)
    }

    const response = await this.request(
      {
        path: `/display/ad_groups/{id}`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters.id))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      DisplayAdGroupResponseFromJSON(jsonValue)
    )
  }

  /**
   * This method returns details about a specific display ad group, and optionally includes performance analytics. You must specify the display ad group ID and optional search criteria to limit the data returned in the analytics.      <h3>Targeting shortcuts</h3>     <table>      <tr>         <th>Name</th>         <th>Description</th>         <th>Sample user_targeting</th>      </tr>      <tr>         <td>NEW_TO_INSTACART</td>         <td>Target any customer adding to their first few carts.</td>         <td>            { \'new_to_instacart\': true }         </td>      </tr>      <tr>         <td>NEW_TO_CATEGORY_OR_BRAND</td>         <td>Reach customers who have never purchased from your brand or chosen categories.</td>         <td>            {            \'purchase\': [            {            \'categories\': [            \'DAIRY\'            ],            \'lookback_window\': \'30d\',            \'clause\': \'exclude\'            }            ]            }         </td>      </tr>      <tr>         <td>BUY_MY_CATEGORY_NOT_MY_BRAND</td>         <td>Get your brand in front of customers buying similar items from competitors.</td>         <td>            {            \'purchase\': [            {            \'categories\': [            \'DAIRY\'            ],            \'lookback_window\': \'30d\',            \'clause\': \'include\'            },            {            \'brand_ids\': [            \'912639\'            ],            \'lookback_window\': \'30d\',            \'clause\': \'exclude\'            }            ]            }         </td>      </tr>      <tr>         <td>BUY_MY_BRAND_NOT_MY_PRODUCT</td>         <td>Introduce a new product or upsell other items an existing customer might like.</td>         <td>            {            \'purchase\': [            {            \'brand_ids\': [            \'912639\'            ],            \'lookback_window\': \'30d\',            \'clause\': \'include\'            },            {            \'upcs\': [            \'00070153201005\'            ],            \'lookback_window\': \'30d\',            \'clause\': \'exclude\'            }            ]            }         </td>      </tr>      <tr>         <td>INTERACT_WITH_X_NOT_BUY_BRAND</td>         <td>Target customers who interact via search, clicking an item details page, or adding to cart.</td>         <td>            {            \'purchase\': [            {            \'brand_ids\': [            \'912639\'            ],            \'lookback_window\': \'30d\',            \'clause\': \'exclude\'            }            ],            \'interest\': [            {            \'categories\': [            \'DAIRY\'            ],            \'lookback_window\': \'30d\',            \'clause\': \'include\'            }            ]            }         </td>      </tr>      <tr>         <td>LAPSED_BUYER</td>         <td>Re-engage customers who haven\'t purchased your brand or category in X days.</td>         <td>            {            \'purchase\': [            {            \'brand_ids\': [            \'912639\'            ],            \'lookback_window\': \'30d\',            \'clause\': \'include\'            },            {            \'brand_ids\': [            \'912639\'            ],            \'lookback_window\': \'60d\',            \'clause\': \'exclude\'            }            ]            }         </td>      </tr>      <tr>         <td>LOYAL_BUYER</td>         <td>Deepen brand loyalty by encouraging repeat purchases from recent customers.</td>         <td>            {            \'purchase\': [            {            \'brand_ids\': [            \'912639\'            ],            \'lookback_window\': \'30d\',            \'clause\': \'include\'            }            ]            }         </td>      </tr>   </table>
   * Retrieve a display ad group
   */
  async getDisplayAdGroupsId(
    requestParameters: GetDisplayAdGroupsIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<DisplayAdGroupResponse> {
    const response = await this.getDisplayAdGroupsIdRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   * This method will return detailed analytics information on a given Display Ad Group. You must specify the metric you wish to use and the date range to filter the information with.
   * Returns analytics for a given Display Ad Group
   */
  async getDisplayAdGroupsIdAnalyticsRaw(
    requestParameters: GetDisplayAdGroupsIdAnalyticsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetDisplayAdGroupAnalyticsResponse>> {
    if (requestParameters.metric === null || requestParameters.metric === undefined) {
      throw new runtime.RequiredError(
        'metric',
        'Required parameter requestParameters.metric was null or undefined when calling getDisplayAdGroupsIdAnalytics.'
      )
    }

    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter requestParameters.id was null or undefined when calling getDisplayAdGroupsIdAnalytics.'
      )
    }

    const queryParameters: any = {}

    if (requestParameters.metric !== undefined) {
      queryParameters['metric'] = requestParameters.metric
    }

    if (requestParameters.analyticsType !== undefined) {
      queryParameters['analytics_type'] = requestParameters.analyticsType
    }

    if (requestParameters.dateRangeStartDate !== undefined) {
      queryParameters['date_range[start_date]'] = requestParameters.dateRangeStartDate
    }

    if (requestParameters.dateRangeEndDate !== undefined) {
      queryParameters['date_range[end_date]'] = requestParameters.dateRangeEndDate
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (requestParameters.xApiKey !== undefined && requestParameters.xApiKey !== null) {
      headerParameters['X-Api-Key'] = String(requestParameters.xApiKey)
    }

    if (requestParameters.xSecretKey !== undefined && requestParameters.xSecretKey !== null) {
      headerParameters['X-Secret-Key'] = String(requestParameters.xSecretKey)
    }

    const response = await this.request(
      {
        path: `/display/ad_groups/{id}/analytics`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters.id))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      GetDisplayAdGroupAnalyticsResponseFromJSON(jsonValue)
    )
  }

  /**
   * This method will return detailed analytics information on a given Display Ad Group. You must specify the metric you wish to use and the date range to filter the information with.
   * Returns analytics for a given Display Ad Group
   */
  async getDisplayAdGroupsIdAnalytics(
    requestParameters: GetDisplayAdGroupsIdAnalyticsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetDisplayAdGroupAnalyticsResponse> {
    const response = await this.getDisplayAdGroupsIdAnalyticsRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   *
   * Create a new Display Ad Group
   */
  async postDisplayAdGroupsRaw(
    requestParameters: PostDisplayAdGroupsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<DisplayAdGroupResponse>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (requestParameters.xApiKey !== undefined && requestParameters.xApiKey !== null) {
      headerParameters['X-Api-Key'] = String(requestParameters.xApiKey)
    }

    if (requestParameters.xSecretKey !== undefined && requestParameters.xSecretKey !== null) {
      headerParameters['X-Secret-Key'] = String(requestParameters.xSecretKey)
    }

    const response = await this.request(
      {
        path: `/display/ad_groups`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: ApiDisplayAdGroupsControllerCreateInputToJSON(requestParameters.body),
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      DisplayAdGroupResponseFromJSON(jsonValue)
    )
  }

  /**
   *
   * Create a new Display Ad Group
   */
  async postDisplayAdGroups(
    requestParameters: PostDisplayAdGroupsRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<DisplayAdGroupResponse> {
    const response = await this.postDisplayAdGroupsRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   * This method will take an existing display ad group, of any state, and duplicate it into a new draft display ad group, with duplicated products and keywords. When successfully called, it returns the task URL you’ll need to hit to retrieve the status of your task, as well as your request’s ID and other metadata.
   * Duplicates an existing display ad group into a draft state
   */
  async postDisplayAdGroupsIdDuplicateAsyncRaw(
    requestParameters: PostDisplayAdGroupsIdDuplicateAsyncRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<AsyncTaskResponse>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter requestParameters.id was null or undefined when calling postDisplayAdGroupsIdDuplicateAsync.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (requestParameters.xApiKey !== undefined && requestParameters.xApiKey !== null) {
      headerParameters['X-Api-Key'] = String(requestParameters.xApiKey)
    }

    if (requestParameters.xSecretKey !== undefined && requestParameters.xSecretKey !== null) {
      headerParameters['X-Secret-Key'] = String(requestParameters.xSecretKey)
    }

    const response = await this.request(
      {
        path: `/display/ad_groups/{id}/duplicate_async`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters.id))
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: ApiDisplayAdGroupsControllerDuplicateAsyncInputToJSON(requestParameters.body),
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, jsonValue => AsyncTaskResponseFromJSON(jsonValue))
  }

  /**
   * This method will take an existing display ad group, of any state, and duplicate it into a new draft display ad group, with duplicated products and keywords. When successfully called, it returns the task URL you’ll need to hit to retrieve the status of your task, as well as your request’s ID and other metadata.
   * Duplicates an existing display ad group into a draft state
   */
  async postDisplayAdGroupsIdDuplicateAsync(
    requestParameters: PostDisplayAdGroupsIdDuplicateAsyncRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<AsyncTaskResponse> {
    const response = await this.postDisplayAdGroupsIdDuplicateAsyncRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   *
   * Submit display ad groups for approval
   */
  async postDisplayAdGroupsSubmitRaw(
    requestParameters: PostDisplayAdGroupsSubmitRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<DisplayAdGroupsResponse>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (requestParameters.xApiKey !== undefined && requestParameters.xApiKey !== null) {
      headerParameters['X-Api-Key'] = String(requestParameters.xApiKey)
    }

    if (requestParameters.xSecretKey !== undefined && requestParameters.xSecretKey !== null) {
      headerParameters['X-Secret-Key'] = String(requestParameters.xSecretKey)
    }

    const response = await this.request(
      {
        path: `/display/ad_groups/submit`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: ApiDisplayAdGroupsControllerSubmitInputToJSON(requestParameters.body),
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      DisplayAdGroupsResponseFromJSON(jsonValue)
    )
  }

  /**
   *
   * Submit display ad groups for approval
   */
  async postDisplayAdGroupsSubmit(
    requestParameters: PostDisplayAdGroupsSubmitRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<DisplayAdGroupsResponse> {
    const response = await this.postDisplayAdGroupsSubmitRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   *
   * Updates the Display Ad Group with the given id
   */
  async putDisplayAdGroupsIdRaw(
    requestParameters: PutDisplayAdGroupsIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<DisplayAdGroupResponse>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter requestParameters.id was null or undefined when calling putDisplayAdGroupsId.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (requestParameters.xApiKey !== undefined && requestParameters.xApiKey !== null) {
      headerParameters['X-Api-Key'] = String(requestParameters.xApiKey)
    }

    if (requestParameters.xSecretKey !== undefined && requestParameters.xSecretKey !== null) {
      headerParameters['X-Secret-Key'] = String(requestParameters.xSecretKey)
    }

    const response = await this.request(
      {
        path: `/display/ad_groups/{id}`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters.id))
        ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: ApiDisplayAdGroupsControllerUpdateInputToJSON(requestParameters.body),
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      DisplayAdGroupResponseFromJSON(jsonValue)
    )
  }

  /**
   *
   * Updates the Display Ad Group with the given id
   */
  async putDisplayAdGroupsId(
    requestParameters: PutDisplayAdGroupsIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<DisplayAdGroupResponse> {
    const response = await this.putDisplayAdGroupsIdRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   *
   * Appeal the ad group with the given id
   */
  async putDisplayAdGroupsIdAppealRaw(
    requestParameters: PutDisplayAdGroupsIdAppealRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<AppealDisplayAdGroupsResponse>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter requestParameters.id was null or undefined when calling putDisplayAdGroupsIdAppeal.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (requestParameters.xApiKey !== undefined && requestParameters.xApiKey !== null) {
      headerParameters['X-Api-Key'] = String(requestParameters.xApiKey)
    }

    if (requestParameters.xSecretKey !== undefined && requestParameters.xSecretKey !== null) {
      headerParameters['X-Secret-Key'] = String(requestParameters.xSecretKey)
    }

    const response = await this.request(
      {
        path: `/display/ad_groups/{id}/appeal`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters.id))
        ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: ApiDisplayAdGroupsControllerAppealInputToJSON(requestParameters.body),
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      AppealDisplayAdGroupsResponseFromJSON(jsonValue)
    )
  }

  /**
   *
   * Appeal the ad group with the given id
   */
  async putDisplayAdGroupsIdAppeal(
    requestParameters: PutDisplayAdGroupsIdAppealRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<AppealDisplayAdGroupsResponse> {
    const response = await this.putDisplayAdGroupsIdAppealRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   *
   * Enables/Disables the Display Ad Group with the given id
   */
  async putDisplayAdGroupsIdEnableRaw(
    requestParameters: PutDisplayAdGroupsIdEnableRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<EnableDisplayAdGroupResponse>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter requestParameters.id was null or undefined when calling putDisplayAdGroupsIdEnable.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (requestParameters.xApiKey !== undefined && requestParameters.xApiKey !== null) {
      headerParameters['X-Api-Key'] = String(requestParameters.xApiKey)
    }

    if (requestParameters.xSecretKey !== undefined && requestParameters.xSecretKey !== null) {
      headerParameters['X-Secret-Key'] = String(requestParameters.xSecretKey)
    }

    const response = await this.request(
      {
        path: `/display/ad_groups/{id}/enable`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters.id))
        ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: ApiDisplayAdGroupsControllerEnableInputToJSON(requestParameters.body),
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      EnableDisplayAdGroupResponseFromJSON(jsonValue)
    )
  }

  /**
   *
   * Enables/Disables the Display Ad Group with the given id
   */
  async putDisplayAdGroupsIdEnable(
    requestParameters: PutDisplayAdGroupsIdEnableRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<EnableDisplayAdGroupResponse> {
    const response = await this.putDisplayAdGroupsIdEnableRaw(requestParameters, initOverrides)
    return await response.value()
  }
}

/**
 * @export
 */
export const GetDisplayAdGroupsSearchCriteriaStatusEnum = {
  Active: 'ACTIVE',
  Appealed: 'APPEALED',
  Approved: 'APPROVED',
  Closed: 'CLOSED',
  Completed: 'COMPLETED',
  Draft: 'DRAFT',
  Editable: 'EDITABLE',
  Ended: 'ENDED',
  Escalated: 'ESCALATED',
  InReview: 'IN_REVIEW',
  OutOfBudget: 'OUT_OF_BUDGET',
  Paused: 'PAUSED',
  Pending: 'PENDING',
  Rejected: 'REJECTED',
  Scheduled: 'SCHEDULED',
  Unknown: 'UNKNOWN',
} as const
export type GetDisplayAdGroupsSearchCriteriaStatusEnum =
  typeof GetDisplayAdGroupsSearchCriteriaStatusEnum[keyof typeof GetDisplayAdGroupsSearchCriteriaStatusEnum]
/**
 * @export
 */
export const GetDisplayAdGroupsSortCriteriaFieldEnum = {
  Name: 'name',
  AnalyticsSpend: 'analytics.spend',
  AnalyticsRoas: 'analytics.roas',
  AnalyticsHaloRoas: 'analytics.halo_roas',
  AnalyticsImpressions: 'analytics.impressions',
  AnalyticsClicks: 'analytics.clicks',
  AnalyticsAvgCtr: 'analytics.avg_ctr',
  AnalyticsDirectSales: 'analytics.direct_sales',
  AnalyticsHaloSales: 'analytics.halo_sales',
  AnalyticsAvgCpm: 'analytics.avg_cpm',
  AnalyticsNtbDirectSales: 'analytics.ntb_direct_sales',
  AnalyticsNtbHaloSales: 'analytics.ntb_halo_sales',
  AnalyticsPercentNtbDirectSales: 'analytics.percent_ntb_direct_sales',
  AnalyticsPercentNtbHaloSales: 'analytics.percent_ntb_halo_sales',
} as const
export type GetDisplayAdGroupsSortCriteriaFieldEnum =
  typeof GetDisplayAdGroupsSortCriteriaFieldEnum[keyof typeof GetDisplayAdGroupsSortCriteriaFieldEnum]
/**
 * @export
 */
export const GetDisplayAdGroupsSortCriteriaDirectionEnum = {
  Asc: 'asc',
  Desc: 'desc',
} as const
export type GetDisplayAdGroupsSortCriteriaDirectionEnum =
  typeof GetDisplayAdGroupsSortCriteriaDirectionEnum[keyof typeof GetDisplayAdGroupsSortCriteriaDirectionEnum]
/**
 * @export
 */
export const GetDisplayAdGroupsIdAnalyticsTypeEnum = {
  Default: 'default',
  Landing: 'landing',
} as const
export type GetDisplayAdGroupsIdAnalyticsTypeEnum =
  typeof GetDisplayAdGroupsIdAnalyticsTypeEnum[keyof typeof GetDisplayAdGroupsIdAnalyticsTypeEnum]
/**
 * @export
 */
export const GetDisplayAdGroupsIdAnalyticsMetricEnum = {
  Impressions: 'impressions',
  AvgCpm: 'avg_cpm',
  Clicks: 'clicks',
  Spend: 'spend',
  PageViews: 'page_views',
  Ctr: 'ctr',
} as const
export type GetDisplayAdGroupsIdAnalyticsMetricEnum =
  typeof GetDisplayAdGroupsIdAnalyticsMetricEnum[keyof typeof GetDisplayAdGroupsIdAnalyticsMetricEnum]
/**
 * @export
 */
export const GetDisplayAdGroupsIdAnalyticsAnalyticsTypeEnum = {
  Default: 'default',
  Landing: 'landing',
} as const
export type GetDisplayAdGroupsIdAnalyticsAnalyticsTypeEnum =
  typeof GetDisplayAdGroupsIdAnalyticsAnalyticsTypeEnum[keyof typeof GetDisplayAdGroupsIdAnalyticsAnalyticsTypeEnum]
